<template>
  <div class="report-content">
    <Table
      :columns="columns"
      :data-source="list"
      :pagination="tablePagination"
      @change="(page) => handleTableChange(page, getTableList)"
    >
      <template #bodyCell="{ column, record }">
        <template v-if="column.key == 'type'">
          <span class="report-content-item">
            {{ typeFilter(record.type) }}
          </span>
        </template>
        <template v-if="column.key == 'taskType'">
          <span>下载任务</span>
        </template>
        <template v-if="column.key == 'status'">
          <span
            :class="
              ['report-waiting', 'report-success', 'report-fail'][record.status]
            "
            >{{ statusFilter(record.status) }}</span
          >
        </template>
        <template v-if="column.key == 'operation'">
          <a v-if="record.status == 1" @click="downLoadTask(record)"> 下载 </a>
          <a
            v-if="record.status == 0 || record.status == 2"
            @click="deleteTask(record)"
          >
            删除
          </a>
        </template>
      </template>
    </Table>
  </div>
</template>
<script setup lang="ts">
import { ref, onMounted, computed, watch } from 'vue';
import { Table, message as Message } from 'ant-design-vue';
import { columns } from './constant';
import { useTablePagination } from '/@/hooks/web/useTablePagination';
import { getDictListApi, taskListApi, deleteTaskApi } from '/@/api/common';
import { useReportStore } from '/@/store/modules/reportDownload';
import { imgPrefix } from '/@/api/common';

const list = ref<any>([]);
const dictList = ref<any>([]);
const STATUS = ref<any>(['待处理', '处理成功', '处理失败']);
const {
  tablePagination,
  setCurrentPage,
  setTotal,
  handleTableChange,
  setPageSize,
} = useTablePagination();
const reportStore = useReportStore();
const showReport = computed(() => {
  return reportStore.showReport;
});

watch(showReport, (val) => {
  if (val) {
    getDictList();
    getTableList();
  }
});

onMounted(() => {
  setCurrentPage(1);
  setPageSize(5);
  getDictList();
  getTableList();
});

const getDictList = async () => {
  try {
    const { content } = await getDictListApi({
      codes: ['report_type'],
    });
    content.forEach((item) => {
      if (item.code == 'report_type') {
        dictList.value = [...item.items];
      }
    });
    console.log('dictList', dictList.value);
  } catch (error) {
    console.log('error', error);
  }
};

const getTableList = async () => {
  try {
    const { current, pageSize } = tablePagination.value;
    const {
      content: { currentList, totalSize },
    } = await taskListApi({ page: current, pageSize: pageSize });
    setTotal(totalSize);
    list.value = currentList || [];
  } catch (error) {
    console.log('err', error);
  }
};

const statusFilter = (val) => {
  console.log('val', STATUS.value[val]);
  return STATUS.value[val] ? STATUS.value[val] : '--';
};

const typeFilter = (val) => {
  let valueList: any = [];
  if (dictList.value?.length) {
    valueList = dictList.value.filter((item) => item.value == val);
  }
  return valueList?.length ? valueList[0].label : val;
};

const downLoadTask = (item) => {
  window.open(imgPrefix + item.url);
};

const deleteTask = async (item) => {
  console.log('item', item);
  try {
    await deleteTaskApi({ pkId: item.pkId });
    Message.success('删除成功！');
    getTableList();
  } catch (error) {
    console.log('err', error);
  }
};
</script>
<style lang="less" scoped>
.report-content {
  .report-content-item {
    word-wrap: break-word;
    word-break: break-all;
    white-space: normal;
  }
}
.report-waiting {
  color: #ff9900;
}
.report-success {
  color: #17b666;
}
.report-fail {
  color: #ff4949;
}
</style>
